


import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { BonusPobjednici } from '../../Layout/BonusPobjednici.jsx'

export class FlopUtrkaBody extends React.Component {

    constructor(props) {
        super(props);
        this.state = { tabs: ['Pravila', 'Nagrade', 'Uvjeti', 'Rezultati'], selectedTab: null }


        this.gotoTab = this.gotoTab.bind(this);
        this.getBody = this.getBody.bind(this);


        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Flop utrka', 'poker', this.props.user);
    }

    componentDidMount() {
        this.gotoTab(this.state.tabs[0]);
    }

    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }
    getBody() {

        if (this.state.selectedTab == 'Pravila') {
            return (<div className="padding-sides-medium-2">
                <h2 className="v3">{this.state.selectedTab}</h2>
                Pravila su jednostavna, a bodove za plasman skupljate na slijedeći način:
                <br /><br />
                <ul className='list'>
                    <li>1 bod ćete dobiti za svaki Flop koji vidite sa svoje dvije karte u ruci na stolovima 0,25 €/0,5 €</li>
                    <li>1.5 boda ćete dobiti za svaki Flop koji vidite sa svoje dvije karte u ruci na stolovima 0,5 €/1,00 €</li>
                    <li>2 boda ćete dobiti za svaki Flop koji vidite sa svoje dvije karte u ruci na stolovima 1,00 €/2,00 €</li>
                    {/*<li>Dodatno osvojite do maksimalno 200 bodova ukoliko imate gubitni dan, na kvalificiranim stolovima. 1 bod za svakih izgubljenih 10kn u danu.</li>*/}
                    {/*<li>Dodatno osvojite do maksimalnih 500 bodova ukoliko imate gubitni tjedan na kvalificiranim stolovima. 1 bod za svakih 10kn izgubljenih u pojedinačnom tjednu natjecanja.</li>*/}
                </ul>
                <br /><br />
                <i>*Vidjeti Flop znači da niste odustali od svoje ruke prije nego je podijeljen Flop.</i>
                <br></br>
                <br></br>
                <a target="_blank" style={{ color: '#1d7b60', textDecoration: 'underline' }} href={'https://cdn.supersport.hr/Casino/Poker/Pravila/PokerFlopUtrka08_2022.pdf' + '?c=' + casino.config.guiCacheVerzija}>Pravila promocije</a>
            </div>)
        }

        if (this.state.selectedTab == 'Nagrade') {
            return (<div>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">{this.state.selectedTab}</h2>
                    Za navedene kvalificirane stolove dijele se bonusi prema sljedećim tablicama:
                    <br /><br />
                </div>
                <table className="table-1 v2">
                    <thead>
                        <tr>
                            <th className="text-left text text-6">Natjecanje</th>
                            <th className="text-right text text-6">Nagrade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="horizontal-lines">
                            <td className="text text-1">21.08.2023. 00:00h - 27.08.2023. 23:59h</td>
                            <td className="text-right text text-7 nowrap">3.000,00 €</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <table className="table-1 v2">
                    <thead>
                        <tr>
                            <th className="text-left text text-6">Plansman</th>
                            <th className="text-right text text-6">Nagrada</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="horizontal-lines">
                            <td className="text text-1">1.</td>
                            <td className="text-right text text-7 nowrap">500,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">2.</td>
                            <td className="text-right text text-7 nowrap">250,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">3.</td>
                            <td className="text-right text text-7 nowrap">160,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">4. - 10.</td>
                            <td className="text-right text text-7 nowrap">70,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">11. - 20.</td>
                            <td className="text-right text text-7 nowrap">35,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">21. - 50.</td>
                            <td className="text-right text text-7 nowrap">15,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">51. - 100.</td>
                            <td className="text-right text text-7 nowrap">8,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">101. - 200.</td>
                            <td className="text-right text text-7 nowrap">4,00 €</td>
                        </tr>
                    </tbody>
                </table>
            </div>)
        }

        if (this.state.selectedTab == 'Uvjeti') {

            return <div className="padding-sides-medium-2">
                <h2 className="v3">{this.state.selectedTab}</h2>
                <ul className='list'>
                    <li>Flop utrka počinje 21. kolovoza 2023. u 00:00 sati i traje do 27. kolovoza 2023. u 23:59 sati.</li>
                    <li>Dan za vrijeme promocije traje od 00:00h do 23:59h.</li>
                    <li>Nagrade će biti isplaćene odmah nakon završetka natjecanja prema plasmanu igrača na tablici</li>
                    <li>Vidjeti Flop znači da niste odustali od svoje ruke prije nego je podijeljen Flop</li>
                    <li>Svi stolovi na kojima se igra small i big blind 0.75/1.5, 1/2, 1.5/3, 2/4, 2.5/5, 3/6 i 7.5/15 će se kvalificirati za bodove</li>
                    {/*<li>Gubitni dan znači gubitak u igri na cash stolovima za pojedini dan za vrijeme trajanja promocije</li>*/}
                    {/*<li>Gubitni tjedan znači gubitak u igri na cash stolovima za pojedini tjedan za vrijeme trajanja promocije i unutar vremena određenim u stavki 3.</li>*/}
                    {/*<li>Dodatni bodovi se osvajaju po danu prema izgubljenom novcu do maksimalnih 200 bodova. 1 bod za svakih igubljenih 10kn (1,33€).</li>*/}
                    {/*<li>Dodatni bodovi se osvajaju po tjednu prema izgubljenom novcu do maksimalnih 500 bodova. 1 bod za svakih igubljenih 10kn (1,33€).</li>*/}
                    <li>U slučaju jednakog broja bodova igračima se isplaćuje zbirna nagrada za isti plasman.</li>
                    <li>SuperSport zadržava pravo promijeniti pravila natjecanja u bilo koje vrijeme</li>
                    <li>Primjenjuju se opća pravila SuperSporta te Pravila pokera</li>
                </ul>
            </div>
        }


        if (this.state.selectedTab == 'Rezultati') {
            return <div>
                <h2 className="v3 padding-sides-medium-2">{this.state.selectedTab}</h2>
                <BonusPobjednici {...this.props} />
            </div>
        }
    }
    render() {
        return <div>
            <div className="segment v2 margin-top-small padding-sides-medium">
                {this.state.tabs && this.state.tabs.map((tab) =>
                    <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                )}
            </div>
            {this.getBody()}
        </div>

    }
};
